import axios from "../../../../utils/axios_interceptor"
import { getAcApiUrl } from '../../../../utils/helper';
import { getAll } from '../../../../utils/loginSession';

export const enums = {
  SET_REGULARPURCHASERS_STATE: {
    type: 'SET_REGULARPURCHASERS_STATE',
    state: 'regularPurchaser',
    url: 'queryRegularPurchaser',
  },
  SET_VALIDATE_PURCHASER_STATE: {
    type: 'SET_VALIDATE_PURCHASER_STATE',
    state: 'validatePurchaser',
    url: 'validateUser',
  },
  SET_ADD_FREQUENTCONTACTS_STATE: {
    type: 'SET_ADD_FREQUENTCONTACTS_STATE',
    state: 'addFrequent',
    url: 'addUser',
  },
  SET_DELETE_REGULARPURCHASER_STATE: {
    type: 'SET_DELETE_REGULARPURCHASER_STATE',
    state: 'delPurchaser',
    url: 'delUser',
  },
  SET_IPTNAME_STATE: { type: 'SET_IPTNAME_STATE', state: 'iptName', url: 'getIptName' },
  SET_PICKUP_STATE: { type: 'SET_PICKUP_STATE', state: 'callback', url: 'profileSW' },
  SET_RECIPIENT_STATE: { type: 'SET_RECIPIENT_STATE', state: 'callback', url: 'address' },
  SET_SWITCHSTATUS_STATE: { type: 'SET_SWITCHSTATUS_STATE', state: 'content' },
};

export const setState = (type, state) => {
  return {
    type: type.type,
    payload: state,
  };
};

export const fetchState =
  (type, data = {}) =>
    async (dispatch, getState) => {
      try {
        const apiUrl = getAcApiUrl();
        const login = getAll(getState());
        if (type.type === 'SET_REGULARPURCHASERS_STATE')
          dispatch(setState(type, { isloading: true }));

        const res = await axios({
          headers: login.accessHeader,
          method: 'post',
          url: `${apiUrl}/${type.url}`,
          data: data,
        });

        if (type === enums.SET_RECIPIENT_STATE) {
          if (res.data && res.data.data && res.data.data.addressItems) {
            const addresses = res.data.data.addressItems;
            let addressDefault = addresses.filter(item => item.addressType === "S")[0];
            if (addressDefault == undefined) {
              addressDefault = addresses.filter(item => item.addressType === "A")[0] || {};
              if(JSON.stringify(addressDefault) === '{}'){
                addressDefault = addresses.filter(item => item.addressNumber === 1)[0] ;
              }
            }

            dispatch(setState(type, addressDefault));
          }
        } else {
          dispatch(setState(type, res.data));
        }

        return res.data;
      } catch (err) {
        console.log(err);
      }
    };

export const fetchAddressState =
  (type, data = {}) =>
    async (dispatch, getState) => {
      try {
        const apiUrl = getAcApiUrl();
        const login = getAll(getState());
        const res = await axios({
          headers: login.accessHeader,
          method: 'post',
          url: `${apiUrl}/${type.url}`,
          data: { ...data, ...login },
        });
        dispatch(setState(type, res.data));
        return res.data;
      } catch (err) {
        console.log(err);
      }
    };
//TEP-12419
export const fetchSwitchStatusState = () => async (dispatch) => {
  try {
    const apiUrl = getAcApiUrl();
    const res = await axios({
      headers: getAccessHeader(),
      method: 'post',
      url: `${apiUrl}/fetchaSwitchStatusState`,
      data: {},
    });
    await dispatch(setState(enums.SET_SWITCHSTATUS_STATE, res.data));
  } catch (err) {
    console.log(err);
  }
};
// state
const recipientState = (state = {}, action) => {
  switch (action.type) {
    // for special case

    // for use enum
    default:
      if (enums[action.type]) {
        return {
          ...state,
          [enums[action.type].state]: action.payload,
        };
      }

      // for default
      return state;
  }
};

export default {
  recipientState,
  fetchSwitchStatusState,
};
